import React from 'react';
import { WheelPositions } from './AlloyRepairRequestTypes';
import AlloyWheelSelectionImage from '../../../images/Alloy_Car_Image.png';
import { t } from 'i18next';

export type CarComponentProps = {
    selectedWheels: string[];
    onWheelSelected: (wheel: string) => void;
    isLeftHandDrive?: boolean;
};

const CarComponent = ({
    selectedWheels,
    onWheelSelected,
    isLeftHandDrive
}: CarComponentProps): JSX.Element => {
    const onImageClick = (wheel: string) => {
        onWheelSelected(wheel);
    };
    return (
        <div style={{ height: 400, width: 300 }}>
            <svg style={{ height: 400, width: 300 }}>
                <defs>
                    <pattern
                        id='img1'
                        patternUnits='userSpaceOnUse'
                        x='0'
                        y='0'
                        width='300'
                        height='400'>
                        <image
                            href={AlloyWheelSelectionImage}
                            width='300'
                            height='400'
                        />
                    </pattern>
                </defs>
                <path
                    d='M5,5
        l0,680 l980,0 l0,-680 l-980,0'
                    fill='url(#img1)'
                />
                <circle
                    cx='77'
                    cy='123'
                    r='19'
                    data-testid='passenger-front-circle'
                    className={
                        selectedWheels.includes(
                            isLeftHandDrive
                                ? t('tyre_repair_request.driver_front_tyre')
                                : WheelPositions.PassengerFront
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(
                            t(
                                isLeftHandDrive
                                    ? t('tyre_repair_request.driver_front_tyre')
                                    : WheelPositions.PassengerFront
                            )
                        );
                    }}>
                    <title>
                        {t(
                            isLeftHandDrive
                                ? 'tyre_repair_request.driver_front_tyre'
                                : 'alloy_repair_request.passenger_front_wheel'
                        )}
                    </title>
                </circle>
                <circle
                    cx='223'
                    cy='123'
                    r='19'
                    data-testid='driver-front-circle'
                    className={
                        selectedWheels.includes(
                            isLeftHandDrive
                                ? t('tyre_repair_request.passenger_front_tyre')
                                : WheelPositions.DriverFront
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(
                            isLeftHandDrive
                                ? t('tyre_repair_request.passenger_front_tyre')
                                : WheelPositions.DriverFront
                        );
                    }}>
                    <title>
                        {t(
                            isLeftHandDrive
                                ? 'tyre_repair_request.passenger_front_tyre'
                                : 'alloy_repair_request.driver_front_wheel'
                        )}
                    </title>
                </circle>
                <circle
                    cx='77'
                    cy='272'
                    r='19'
                    data-testid='passenger-rear-circle'
                    className={
                        selectedWheels.includes(
                            isLeftHandDrive
                                ? t('tyre_repair_request.driver_rear_tyre')
                                : WheelPositions.PassengerRear
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(
                            isLeftHandDrive
                                ? t('tyre_repair_request.driver_rear_tyre')
                                : WheelPositions.PassengerRear
                        );
                    }}>
                    <title>
                        {t(
                            isLeftHandDrive
                                ? 'tyre_repair_request.driver_rear_tyre'
                                : 'alloy_repair_request.passenger_rear_wheel'
                        )}
                    </title>
                </circle>
                <circle
                    cx='223'
                    cy='272'
                    r='19'
                    data-testid='driver-rear-circle'
                    className={
                        selectedWheels.includes(
                            isLeftHandDrive
                                ? t('tyre_repair_request.passenger_rear_tyre')
                                : WheelPositions.DriverRear
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(
                            isLeftHandDrive
                                ? t('tyre_repair_request.passenger_rear_tyre')
                                : WheelPositions.DriverRear
                        );
                    }}>
                    <title>
                        {t(
                            isLeftHandDrive
                                ? 'tyre_repair_request.passenger_rear_tyre'
                                : 'alloy_repair_request.driver_rear_wheel'
                        )}
                    </title>
                </circle>
            </svg>
        </div>
    );
};

export default CarComponent;
